import {
  HttpRequestOrHttpRequestFactory,
  RequestOverrides,
} from '@wix/fe-essentials/http-client';

export interface HttpClient {
  request<T>(
    req: HttpRequestOrHttpRequestFactory<T>,
    overrides?: RequestOverrides,
  ): Promise<{
    data: T;
    status: number;
    statusText: string;
    headers: Record<string, string | undefined>;
  }>;
}
